import {ComGroupIdentity, UserIdentity} from '../../models';

export enum WikiSuggestLayers {
    People = 'people',
    Groups = 'groups',
    Departments = 'departments',
}

export interface WikiSuggestPerson {
    layer: WikiSuggestLayers.People;
    title: string;
    identity: UserIdentity;
    login: string;
    department_name: string;
    is_dismissed: boolean;
    avatar_url: string;
}

export interface WikiSuggestGroup {
    layer: WikiSuggestLayers.Groups;
    identity: ComGroupIdentity;
    title: string;
}

export interface WikiSuggestDepartment {
    layer: WikiSuggestLayers.Departments;
    identity: ComGroupIdentity;
    title: string;
}
